/**
 * Legacy API service — re-exports the shared apiClient so existing page
 * components continue to work without modification during the migration.
 *
 * New code should import apiClient directly from:
 *   import apiClient from '../shared/api/client';
 */

import apiClient from '../shared/api/client';

export default apiClient;
